import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import ReactModal from 'react-modal';

import { i18next } from '../../../internationalization/i18next';
import { CheckItem } from '../../widgets/check-item/check-item';

ReactModal.setAppElement('#root');

export interface Item<T> {
  id: string;
  selected: boolean;
  value: T;
  disabled?: boolean;
}

interface SearchableCheckItemSetProps<T> {
  items: Item<T>[];

  label(t: T): string;
  hintText(t: T): string;
  onChange(id: string): void;

  selectAllVisible: boolean;
}

@observer
export class SearchableCheckItemSet<T> extends React.Component<SearchableCheckItemSetProps<T>> {
  @computed
  get selectedSize(): number {
    return this.props.items.filter(i => i.selected).length;
  }

  @computed
  get isAllSelected(): boolean {
    const totalSize = this.props.items.length;
    return this.selectedSize === totalSize;
  }

  @computed
  get isNoneSelected(): boolean {
    return this.selectedSize === 0;
  }

  selectAll = (): void => {
    if (this.isAllSelected) {
      this.props.items.map(i => this.props.onChange(i.id));
      return;
    }
    this.props.items.filter(i => !i.selected).map(i => this.props.onChange(i.id));
  };

  renderCheckItems(): JSX.Element {
    return (
      <>
        {this.props.selectAllVisible ? (
          <CheckItem
            size={'xsmall'}
            selected={this.isAllSelected}
            indeterminate={!this.isAllSelected && !this.isNoneSelected}
            label={i18next.t('checkitem-set.select-all', 'Select All')}
            onChange={this.selectAll}
          />
        ) : (
          undefined
        )}
        {Object.values(this.props.items).map(item => {
          return (
            <CheckItem
              size={'xsmall'}
              key={item.id}
              selected={item.selected}
              label={this.props.label(item.value)}
              hintText={this.props.hintText(item.value)}
              onChange={item.disabled === undefined || !item.disabled ? () => this.props.onChange(item.id) : undefined}
              disabled={item.disabled}
            />
          );
        })}
      </>
    );
  }

  render() {
    return <>{this.renderCheckItems()}</>;
  }
}



// WEBPACK FOOTER //
// ./src/ui/widgets/searchable-check-item-set/searchable-check-item-set.tsx